export enum EquipmentClass {
    Unknown = 0,
    Food = 1,
    Feed = 2,
    Technical =  3
}